import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';
import { NgOption } from '@ng-select/ng-select';

import { AuthService } from '../services/auth.service';
import { DespesaService } from '../services/despesa.service';
import { ProfissionalService } from '../services/profissional.service';
import { TipoDespesaService } from '../services/tipo-despesa.service';
import { FornecedorService } from '../services/fornecedor.service';
import { UnidadeMedidaService } from '../services/unidade-medida.service';
import { VeiculoService } from '../services/veiculo.service';
import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';

@Component({
	selector: 'app-despesas-edit',
	templateUrl: './despesas-edit.component.html',
	styleUrls: ['./despesas-edit.component.css'],
	animations: [loadingFade]
})
export class DespesasEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public despesa_id = null;

	public formDespesa: FormGroup;
	public tipo_despesa_array = [];
	public veiculo_array: NgOption[] = [];
	public fornecedor_array = [];
	public unidade_medida_array = [];
	public situacao_array = [
		{despesa_situacao_id: 'A', despesa_situacao_nome: 'Situação A'},
		{despesa_situacao_id: 'B', despesa_situacao_nome: 'Situação B'}
	];

	public qtde_char_descricao = 0;

	// datepickers
	public data_compra_dp;

	constructor(private authSvc: AuthService,
				private route: ActivatedRoute,
				private fb: FormBuilder,
				private despesaSvc: DespesaService,
				private fornecedorSvc: FornecedorService,
				private profSvc: ProfissionalService,
				private router: Router,
				private tipoDespesaSvc: TipoDespesaService,
				private unidadeMedidaSvc: UnidadeMedidaService,
				private veiculoSvc: VeiculoService) { }

	ngOnInit() {
		this.criaForm();
		this.loading = true;

		this.route.params.subscribe( params => {
			if (params.id) {
				this.despesa_id = params.id;
				// pega dados a partir do id
				this.despesaSvc.getDespesa(params.id).then((data: any) => {
					let data_compra = null
					if (moment(data.despesa_data_compra).isValid()) {
						let moment_date = moment(data.despesa_data_compra, 'YYYY-MM-DD');
						data_compra = moment_date.format('DD/MM/YYYY');
						this.data_compra_dp.setDate(moment_date.toDate());
					}

					this.preencheForm({
						despesa_id: data.despesa_id,
						usuario_id: this.authSvc.getUsuarioId(),
						unidade_id: data.unidade_id,
						cliente_id: data.cliente_id,
						veiculo_id: data.veiculo_id,
						tipo_despesa_id: data.tipo_despesa_id,
						fornecedor_id: data.fornecedor_id,
						despesa_planejado: data.despesa_planejado,
						despesa_quantidade: data.despesa_quantidade,
						unidade_medida_id: data.unidade_medida_id,
						despesa_valor: data.despesa_valor,
						despesa_data_compra: data_compra,
						despesa_descricao: data.despesa_descricao,
						despesa_situacao: data.despesa_situacao,
						despesa_solicitante: data.despesa_solicitante,
						despesa_aprovador: data.despesa_aprovador,
					});

					if (data.despesa_descricao)
						this.qtde_char_descricao = data.despesa_descricao.length;

					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formDespesa = this.fb.group({
			despesa_id: null,
			usuario_id: this.authSvc.getUsuarioId(),
			unidade_id: '',
			cliente_id: '',
			veiculo_id: ['', Validators.required],
			tipo_despesa_id: ['', Validators.required],
			fornecedor_id: '',
			despesa_planejado: ['', Validators.required],
			despesa_quantidade: ['', Validators.required],
			unidade_medida_id: ['', Validators.required],
			despesa_valor: ['', Validators.required],
			despesa_data_compra: [null, Validators.required],
			despesa_descricao: ['', Validators.maxLength(200)],
			despesa_situacao: ['', Validators.required],
			despesa_solicitante: ['', Validators.maxLength(100)],
			despesa_aprovador: ['', Validators.maxLength(100)]
		});

		this.pegaVeiculos();
		this.pegaTipoDespesas();
		this.pegaFornecedores();
		this.pegaUnidadesMedida();

		moment.locale('pt-Br');
		this.data_compra_dp = Datepicker('#despesa_data_compra', {
			customMonths: moment.months(),
			customDays: moment.weekdaysShort(),
			overlayPlaceholder: 'Preencha o ano',
			overlayButton: 'Enviar',
			formatter: (element, date) => {
				let formatted = moment(date).format('DD/MM/YYYY');
				this.formDespesa.controls['despesa_data_compra'].setValue(formatted);
			}
		});
	}

	pegaVeiculos() {
		this.veiculoSvc.getVeiculos('veiculo_placa').then((data: any[]) => {
			let aux = []
			for (let v of data) {
				aux.push({
					veiculo_id: v.veiculo_id,
					veiculo_label: v.veiculo_placa + ' - ' + v.veiculo_numero,
					unidade_id: v.unidade_id,
					cliente_id: v.cliente_id
				});
			}
			this.veiculo_array = aux;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaTipoDespesas() {
		this.tipoDespesaSvc.getTiposDespesa('tipo_despesa_nome').then((data: any[]) => {
			this.tipo_despesa_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaFornecedores() {
		this.fornecedorSvc.getFornecedores('fornecedor_nome').then((data: any[]) => {
			this.fornecedor_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaUnidadesMedida() {
		this.unidadeMedidaSvc.getUnidadesMedida('unidade_medida_nome').then((data: any[]) => {
			this.unidade_medida_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	preencheForm(dados) {
		this.formDespesa.setValue(dados);
	}

	onChangeVeiculo(e) {
		this.formDespesa.controls['unidade_id'].setValue(e.unidade_id);
		this.formDespesa.controls['cliente_id'].setValue(e.cliente_id);
	}

	enviaDespesa() {
		if (this.formDespesa.valid) {
			this.submitting = true;

			let toSend = this.formDespesa.value;

			console.log('toSend', toSend)
			if (this.despesa_id === null) { // criar
				this.despesaSvc.criaDespesa(toSend).then((data) => {
					console.log('resp', data);
					this.router.navigate(['home/despesas']);
				}).catch(err => {
					console.log(err);
				});
			}
			else { // editar
				this.despesaSvc.editaDespesa(toSend).then((data) => {
					console.log('resp', data);
					this.router.navigate(['home/despesas']);
				}).catch(err => {
					console.log(err);
				});
			}
		}
	}

	onKeyUpDescricao(e) {
		this.qtde_char_descricao = this.formDespesa.value.despesa_descricao.length;
	}
	
	invalid(nome) {
		let input = this.formDespesa.get(nome);
		return input.touched && input.invalid;
	}
}
